import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-new-contact-grid.scss'
import {handleChatClick} from '@/scripts/util/chat'

export default register(`section-new-contact-grid`, {
    onLoad() {
        if (document.querySelector(`[data-chat]`)) {
            document.querySelector(`[data-chat]`).addEventListener(`click`, handleChatClick)
        }
    },
    
    onUnload() {
        if (document.querySelector(`[data-chat]`)) {
            document.querySelector(`[data-chat]`).removeEventListener(`click`, handleChatClick)
        }
    }
})
